import { metaSeparator } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { Fragment } from 'react'
import styles from './music-line.module.css'

export interface MusicLineProps {
  /** Segments in reading order, e.g. ['Cover of Fleetwood Mac', 'F major', '4:12'] */
  parts: string[]
}

/** A song card's music line. Only the last segment may truncate, so the line never shows more than one ellipsis. */
export const MusicLine: FC<MusicLineProps> = props => {
  const { parts } = props
  const last = parts.length - 1
  return (
    <span className={styles.line} data-testid="music-line">
      {parts.map((part, idx) => (
        <Fragment key={`${idx}-${part}`}>
          {idx > 0 ? <span aria-hidden="true">{metaSeparator}</span> : null}
          <span
            className={idx === last ? styles.truncates : styles.segment}
            data-testid="music-line-segment"
            data-truncates={idx === last ? '' : undefined}
          >
            {part}
          </span>
        </Fragment>
      ))}
    </span>
  )
}
